import API from '@/services/http'

export const getWebSoketMsgById = (wsMsgId: string) =>
  API.admin.post<{ success: boolean; payload: string }>('/oneclub-api/api/message/get_websocket_msg', {
    wsMsgId,
  })
